<h1 mat-dialog-title>{{ data.data.title }}</h1>
<div mat-dialog-content>
    <img *ngIf="icon" alt="Confirmation icon" [src]="icon" class="icon" />

    <p *ngIf="message" [innerHtml]="message"></p>

    <ng-scrollbar *ngIf="elementList.length>0">
        <p class="elementlist-element" *ngFor="let element of elementList">{{ element }}</p>
    </ng-scrollbar>

    <p *ngIf="warning" class="warning" [innerHtml]="warning"></p>
</div>

<div mat-dialog-actions>
    <button *ngIf="buttons[0]" mat-button [mat-dialog-close]="true">{{ buttons[0] }}</button>
    <button *ngIf="buttons[1]" mat-button [mat-dialog-close]="false">{{ buttons[1] }}</button>
</div>